/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdresseDoublonDto
 */
export interface AdresseDoublonDto {
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonDto
     */
    idadresseToKeep?: number;
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonDto
     */
    idtypeAdresse?: number;
}

/**
 * Check if a given object implements the AdresseDoublonDto interface.
 */
export function instanceOfAdresseDoublonDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdresseDoublonDtoFromJSON(json: any): AdresseDoublonDto {
    return AdresseDoublonDtoFromJSONTyped(json, false);
}

export function AdresseDoublonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdresseDoublonDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idadresseToKeep': !exists(json, 'idadresseToKeep') ? undefined : json['idadresseToKeep'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'idtypeAdresse': !exists(json, 'idtypeAdresse') ? undefined : json['idtypeAdresse'],
    };
}

export function AdresseDoublonDtoToJSON(value?: AdresseDoublonDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idadresseToKeep': value.idadresseToKeep,
        'idpersonne': value.idpersonne,
        'idtypeAdresse': value.idtypeAdresse,
    };
}

